import ModalComponent from '..'
import {
  ProductSearchQuery,
  ProductStatus,
} from '../../../redux-toolkits/products/products.type'
import { Accordion } from '../../accordion'
import { Button } from '../../button'
import { Checkbox } from '../../inputs/Checkbox'
import { SelectCategories } from './selectCategoriesModal'
import { SelectCreators } from './selectCreatorModal'

const ProductStatusFilter: Record<
  ProductStatus | 'all',
  {
    text: string
  }
> = {
  all: {
    text: 'All products',
  },
  active: {
    text: 'Active products',
  },
  inactive: {
    text: 'Inactive products',
  },
}

export const FilterProductsModal = ({
  modalOpen,
  handleModalClose,
  setModalOpen,
  query,
  onSucess,
}: {
  modalOpen: boolean
  handleModalClose: () => void
  setModalOpen: (open: boolean) => void
  query?: ProductSearchQuery
  onSucess: (query: ProductSearchQuery) => void
}) => {
  return (
    <ModalComponent
      open={modalOpen}
      setOpen={setModalOpen}
      onCloseCallback={() => {
        handleModalClose()
      }}
      title={undefined}
      position="right"
    >
      <Button
        label="Reset filters"
        onClick={() => {
          onSucess({
            ...query,
            page: 1,
            status: undefined,
            vendorId: undefined,
          })
        }}
        primary={false}
        variant="plain"
        className="!px-0 !py-0 mb-10"
      />

      <Accordion title="Product Status" className="pb-4 border-b" open={true}>
        <div className="flex flex-col gap-2 w-full">
          {Object.keys(ProductStatusFilter).map((k) => {
            return (
              <Checkbox
                checkStatus={
                  !query?.status && k === 'all' ? true : query?.status === k
                }
                disabled={false}
                handleChange={() => {
                  onSucess({
                    ...query,
                    page: 1,
                    status: k === 'all' ? undefined : (k as ProductStatus),
                  })
                }}
                text={ProductStatusFilter[k as ProductStatus].text}
                textPosition="left"
                className="w-full !justify-between !font-normal"
                key={k}
              />
            )
          })}
        </div>
      </Accordion>

      <Accordion title="Categories" className="py-4 border-b" open={false}>
        <p className="text-sec-black text-sm mb-6">
          {query?.categoryId?.split(',')?.length ?? 0} active{' '}
          {(query?.categoryId?.split(',')?.length ?? 0) === 1
            ? 'filter'
            : 'filters'}
        </p>

        <SelectCategories
          maxSelection={undefined}
          open={true}
          categories={
            query?.categoryId?.split(',')?.map((id) => {
              return {
                _id: id,
              }
            }) ?? []
          }
          setCategories={(c) => {
            onSucess({
              ...query,
              page: 1,
              categoryId: c.map((c) => c._id).join(','),
            })
          }}
        />
      </Accordion>

      <Accordion title="Creators" className="py-4 border-b-0" open={false}>
        <p className="text-sec-black text-sm mb-6">
          {query?.vendorId?.split(',')?.length ?? 0} active{' '}
          {(query?.vendorId?.split(',')?.length ?? 0) === 1
            ? 'filter'
            : 'filters'}
        </p>

        <SelectCreators
          maxSelection={undefined}
          open={true}
          creators={
            query?.vendorId?.split(',')?.map((id) => {
              return {
                _id: id,
                banner: '',
                extendedBio: '',
                logo: '',
                name: '',
                slug: '',
                vendorId: id,
              }
            }) ?? []
          }
          setCreators={(c) => {
            onSucess({
              ...query,
              page: 1,
              vendorId: c.map((c) => c._id).join(','),
            })
          }}
        />
      </Accordion>
    </ModalComponent>
  )
}
